import { defineStore } from 'pinia'
import { Expression, Pagination, PaginationQueryParameters, ToolboxItem } from '@/models'
import { ref } from 'vue'
import { injectTyped } from '@/inject'
import { ServiceKeys } from '@/services/symbols'

export const useGlobalFilterToolboxStore = defineStore('globalFilterToolboxStore', () => {
  const globalfilterToolboxService = injectTyped(ServiceKeys.globalFiltersToolbox)

  const toolboxItems = ref<ToolboxItem[]>([])
  const toolboxPagination = ref<Pagination>()

  async function getToolboxItems(projectId: number, params?: PaginationQueryParameters) {
    const response = await globalfilterToolboxService.getToolboxItems(projectId, params)

    toolboxItems.value = [...toolboxItems.value, ...response.data]
    toolboxPagination.value = response.pagination
  }

  async function getToolboxItemsForExpression(
    projectId: number,
    expression: Expression,
    params?: PaginationQueryParameters,
  ) {
    const response = await globalfilterToolboxService.getToolboxItemsForExpression(
      projectId,
      expression,
      params,
    )

    toolboxItems.value = [...toolboxItems.value, ...response.data]
    toolboxPagination.value = response.pagination
  }

  return {
    toolboxItems,
    toolboxPagination,
    getToolboxItems,
    getToolboxItemsForExpression,
  }
})
